@if ((allowedWeekDays()?.length ?? 0) > 0) {
<div class="tw-w-full tw-border-t tw-border-gray-200 tw-pt-6">
  <div class="{{ !exceptions()?.length ? 'tw-flex-col' : 'tw-items-center'}} tw-mb-3 tw-flex tw-flex-wrap tw-justify-between tw-gap-3">
    <h3 class="tw-text-lg tw-font-bold tw-text-gray-700 tw-font-inter">Exceptions</h3>
    <button
      type="button"
      class="tw-inline-flex tw-w-fit tw-items-center tw-gap-2 tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-text-blue-700 tw-font-inter tw-bg-transparent tw-border-0 tw-px-0 tw-py-2 tw-cursor-pointer focus:tw-outline-none"
      (click)="openAddModal()"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2222 6.22222H7.77778V0.777778C7.77778 0.571498 7.69583 0.373667 7.54997 0.227806C7.40411 0.0819442 7.20628 0 7 0C6.79372 0 6.59589 0.0819442 6.45003 0.227806C6.30417 0.373667 6.22222 0.571498 6.22222 0.777778V6.22222H0.777778C0.571498 6.22222 0.373667 6.30417 0.227806 6.45003C0.0819442 6.59589 0 6.79372 0 7C0 7.20628 0.0819442 7.40411 0.227806 7.54997C0.373667 7.69583 0.571498 7.77778 0.777778 7.77778H6.22222V13.2222C6.22222 13.4285 6.30417 13.6263 6.45003 13.7722C6.59589 13.9181 6.79372 14 7 14C7.20628 14 7.40411 13.9181 7.54997 13.7722C7.69583 13.6263 7.77778 13.4285 7.77778 13.2222V7.77778H13.2222C13.4285 7.77778 13.6263 7.69583 13.7722 7.54997C13.9181 7.40411 14 7.20628 14 7C14 6.79372 13.9181 6.59589 13.7722 6.45003C13.6263 6.30417 13.4285 6.22222 13.2222 6.22222Z" fill="#1C64F2"/>
      </svg>
      Add exception
    </button>
  </div>

  @if (!loading() || exceptions().length) {
    @if (exceptions().length) {
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
        @for (ex of exceptions(); track ex.id) {
          <div
            class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4 tw-flex tw-justify-between tw-flex-col tw-gap-3"
          >
            <div class="tw-flex tw-items-start tw-justify-between tw-gap-2">
              <div class="tw-min-w-0 tw-flex-1 tw-flex tw-flex-col">
                <p class="tw-font-medium tw-text-gray-700 !tw-mb-2 tw-text-base tw-font-inter tw-truncate">{{ ex.title }}</p>
                <p class="tw-text-sm tw-text-gray-500 tw-font-medium tw-font-inter">{{ formatRange(ex) }}</p>
                @if (ex.status === HoursMode.DIFFERENTHOURS) {
                  <p class="tw-text-sm tw-text-gray-500 tw-font-medium tw-font-inter tw-mt-1">{{ formatTimeLine(ex) }}</p>
                }
              </div>
              <div class="tw-flex tw-items-center tw-gap-1 tw-shrink-0">
                <button
                  type="button"
                  class="tw-p-2 tw-rounded-lg tw-text-gray-500 hover:tw-bg-gray-100 hover:tw-text-gray-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                  [ngxTippy]="'Edit'"
                  [tippyProps]="iconActionTippyProps"
                  aria-label="Edit exception"
                  (click)="openEditModal(ex)"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.4516 0.621206L11.1745 1.97018L14.1146 5.07562L15.391 3.72665C15.584 3.52276 15.7372 3.2807 15.8417 3.01428C15.9462 2.74786 16 2.4623 16 2.17393C16 1.88555 15.9462 1.6 15.8417 1.33358C15.7372 1.06716 15.584 0.825093 15.391 0.621206C14.9948 0.222442 14.4685 0 13.9213 0C13.374 0 12.8478 0.222442 12.4516 0.621206Z" fill="#1C64F2"/>
                    <path d="M12.9389 6.31744L9.99872 3.212L6.06991 7.35815C5.95367 7.4807 5.87439 7.63686 5.84208 7.80693L5.40471 10.136C5.37781 10.2778 5.38448 10.4245 5.42413 10.5629C5.46379 10.7014 5.53521 10.8273 5.63204 10.9296C5.72888 11.0319 5.84812 11.1073 5.9792 11.1492C6.11027 11.1911 6.24911 11.1981 6.38338 11.1697L8.5885 10.7042C8.74923 10.6699 8.89677 10.5862 9.01257 10.4636L12.9389 6.31744Z" fill="#1C64F2"/>
                    <path d="M6.06991 7.35815C5.95367 7.4807 5.87439 7.63686 5.84208 7.80693L5.40471 10.136C5.37781 10.2778 5.38448 10.4245 5.42413 10.5629C5.46379 10.7014 5.53521 10.8273 5.63204 10.9296C5.72888 11.0319 5.84812 11.1073 5.9792 11.1492C6.11027 11.1911 6.24911 11.1981 6.38338 11.1697L8.5885 10.7042C8.74923 10.6699 8.89677 10.5862 9.01257 10.4636L12.9389 6.31744L9.99872 3.212L6.06991 7.35815Z" fill="#1C64F2"/>
                    <path d="M9.80581 11.4894C9.57348 11.7344 9.27787 11.9015 8.95602 11.9698L6.01586 12.5907C5.74746 12.6473 5.46997 12.6331 5.20802 12.5493C4.94607 12.4655 4.70776 12.3147 4.51422 12.1103C4.32068 11.9058 4.17791 11.6541 4.09856 11.3774C4.01921 11.1008 4.00574 10.8077 4.05935 10.5242L4.64722 7.41876C4.7119 7.07881 4.87012 6.76659 5.10205 6.5212L9.193 2.20028C9.17025 2.1184 9.15849 2.03355 9.15808 1.94822H1.80185C1.3241 1.94869 0.866052 2.14935 0.528235 2.50615C0.190419 2.86296 0.000440318 3.34676 0 3.85136V14.0969C0.000440318 14.6015 0.190419 15.0853 0.528235 15.4421C0.866052 15.7989 1.3241 15.9995 1.80185 16H11.5021C11.9798 15.9995 12.4379 15.7989 12.7757 15.4421C13.1135 15.0853 13.3035 14.6015 13.3039 14.0969V7.79464L9.80581 11.4894Z" fill="#1C64F2"/>
                  </svg>
                </button>
                <button
                  type="button"
                  class="tw-p-2 tw-rounded-lg tw-text-gray-500 hover:tw-bg-gray-100 hover:tw-text-red-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                  [ngxTippy]="'Remove'"
                  [tippyProps]="iconActionTippyProps"
                  aria-label="Remove exception"
                  (click)="openDeleteModal(ex)"
                >
                  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8519 3.36842H10.5926V1.68421C10.5926 1.23753 10.4209 0.809144 10.1153 0.493294C9.80967 0.177443 9.39517 0 8.96296 0H5.7037C5.2715 0 4.857 0.177443 4.55138 0.493294C4.24577 0.809144 4.07407 1.23753 4.07407 1.68421V3.36842H0.814815C0.598713 3.36842 0.391461 3.45714 0.238654 3.61507C0.0858463 3.77299 0 3.98719 0 4.21053C0 4.43387 0.0858463 4.64806 0.238654 4.80598C0.391461 4.96391 0.598713 5.05263 0.814815 5.05263H1.62963V14.3158C1.62963 14.7625 1.80132 15.1909 2.10694 15.5067C2.41255 15.8226 2.82705 16 3.25926 16H11.4074C11.8396 16 12.2541 15.8226 12.5597 15.5067C12.8653 15.1909 13.037 14.7625 13.037 14.3158V5.05263H13.8519C14.068 5.05263 14.2752 4.96391 14.428 4.80598C14.5808 4.64806 14.6667 4.43387 14.6667 4.21053C14.6667 3.98719 14.5808 3.77299 14.428 3.61507C14.2752 3.45714 14.068 3.36842 13.8519 3.36842ZM5.7037 1.68421H8.96296V3.36842H5.7037V1.68421ZM6.51852 12.6316C6.51852 12.8549 6.43267 13.0691 6.27986 13.227C6.12706 13.385 5.91981 13.4737 5.7037 13.4737C5.4876 13.4737 5.28035 13.385 5.12754 13.227C4.97474 13.0691 4.88889 12.8549 4.88889 12.6316V6.73684C4.88889 6.5135 4.97474 6.29931 5.12754 6.14138C5.28035 5.98346 5.4876 5.89474 5.7037 5.89474C5.91981 5.89474 6.12706 5.98346 6.27986 6.14138C6.43267 6.29931 6.51852 6.5135 6.51852 6.73684V12.6316ZM9.77778 12.6316C9.77778 12.8549 9.69193 13.0691 9.53912 13.227C9.38632 13.385 9.17906 13.4737 8.96296 13.4737C8.74686 13.4737 8.53961 13.385 8.3868 13.227C8.23399 13.0691 8.14815 12.8549 8.14815 12.6316V6.73684C8.14815 6.5135 8.23399 6.29931 8.3868 6.14138C8.53961 5.98346 8.74686 5.89474 8.96296 5.89474C9.17906 5.89474 9.38632 5.98346 9.53912 6.14138C9.69193 6.29931 9.77778 6.5135 9.77778 6.73684V12.6316Z" fill="#E02424"/>
                  </svg>
                </button>
              </div>
            </div>
            @switch (ex.status) {
              @case (HoursMode.DIFFERENTHOURS) {
                <span
                  class="tw-self-start tw-inline-flex tw-items-center tw-rounded tw-px-1 tw-py-0.5 tw-text-xs tw-font-medium tw-font-inter tw-bg-yellow-100 tw-text-yellow-800"
                  >Different hours</span>
              }
              @case (HoursMode.CLOSED) {
                <span
                  class="tw-self-start tw-inline-flex tw-items-center tw-rounded tw-px-1 tw-py-0.5 tw-text-xs tw-font-medium tw-font-inter tw-bg-red-100 tw-text-red-800"
                  >Closed</span>
              }
            }
            
          </div>
        }
      </div>
    }
  }
</div>
}

<modal
  [id]="addModalId"
  [header]="'Add exception'"
  [headerIcon]="addHeaderIcon"
  [showHeader]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="true"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="true"
>
  <div slot="body" class="tw-flex tw-flex-col">
    <app-timing-exception-form
      [titleControl]="addTitleControl"
      [titleInputId]="addTitleInputId"
      [titlePlaceholder]="addTitlePlaceholder"
      [hoursRadioName]="addHoursRadioName"
      [dateInputId]="addDateInputId"
      [dateDisplayControl]="addDateDisplayControl"
      [startDate]="formStartDate()"
      [endDate]="formEndDate()"
      [hoursMode]="formHoursMode()"
      [startHour]="formStartHour()"
      [startMinute]="formStartMinute()"
      [endHour]="formEndHour()"
      [endMinute]="formEndMinute()"
      [timeRangeError]="timeRangeError()"
      [eventPublicStartDate]="eventPublicStartDate()"
      [eventPublicEndDate]="eventPublicEndDate()"
      [disabledDateRanges]="dateRangesClaimedByOtherClosedExceptions()"
      [silentDisabledDateRanges]="silentDisabledDateRangesAfterPublicEnd()"
      [allowedWeekDays]="allowedWeekDays()"
      (rangeSelected)="onFormRangeSelected($event)"
      (hoursModeChange)="onHoursModeChange($event)"
      (startHourChange)="formStartHour.set($event); onTimePartChange()"
      (startMinuteChange)="formStartMinute.set($event); onTimePartChange()"
      (endHourChange)="formEndHour.set($event); onTimePartChange()"
      (endMinuteChange)="formEndMinute.set($event); onTimePartChange()"
    />
  </div>
  <div slot="footer" class="tw-w-full tw-px-6 tw-py-4">
    <button
      type="button"
      class="tw-w-full tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-blue-600 tw-py-3 tw-px-4 tw-text-sm tw-font-medium tw-text-white tw-font-inter hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 disabled:tw-opacity-50"
      [disabled]="savingAdd()"
      (click)="confirmAdd()"
    >
      Confirm
    </button>
  </div>
</modal>

<modal
  [id]="editModalId"
  [header]="'Edit exception'"
  [headerIcon]="editHeaderIcon"
  [showHeader]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="true"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="true"
  (onCloseModal)="onEditModalDismissed()"
>
  <div slot="body" class="tw-flex tw-flex-col">
    <app-timing-exception-form
      [titleControl]="editTitleControl"
      [titleInputId]="editTitleInputId"
      [titlePlaceholder]="editTitlePlaceholder"
      [hoursRadioName]="editHoursRadioName"
      [dateInputId]="editDateInputId"
      [dateDisplayControl]="editDateDisplayControl"
      [startDate]="formStartDate()"
      [endDate]="formEndDate()"
      [hoursMode]="formHoursMode()"
      [startHour]="formStartHour()"
      [startMinute]="formStartMinute()"
      [endHour]="formEndHour()"
      [endMinute]="formEndMinute()"
      [timeRangeError]="timeRangeError()"
      [eventPublicStartDate]="eventPublicStartDate()"
      [eventPublicEndDate]="eventPublicEndDate()"
      [disabledDateRanges]="dateRangesClaimedByOtherClosedExceptions()"
      [silentDisabledDateRanges]="silentDisabledDateRangesAfterPublicEnd()"
      [allowedWeekDays]="allowedWeekDays()"
      (rangeSelected)="onFormRangeSelected($event)"
      (hoursModeChange)="onHoursModeChange($event)"
      (startHourChange)="formStartHour.set($event); onTimePartChange()"
      (startMinuteChange)="formStartMinute.set($event); onTimePartChange()"
      (endHourChange)="formEndHour.set($event); onTimePartChange()"
      (endMinuteChange)="formEndMinute.set($event); onTimePartChange()"
    />
  </div>
  <div slot="footer" class="tw-flex tw-gap-3 tw-px-6 tw-py-4">
    <button
      type="button"
      class="tw-flex-1 tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-py-3 tw-px-4 tw-text-sm tw-font-medium tw-text-gray-900 tw-font-inter hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-gray-300 disabled:tw-opacity-50"
      [disabled]="savingEdit()"
      (click)="resetEditForm()"
    >
      Reset
    </button>
    <button
      type="button"
      class="tw-flex-1 tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-blue-600 tw-py-3 tw-px-4 tw-text-sm tw-font-medium tw-text-white tw-font-inter hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 disabled:tw-opacity-50"
      [disabled]="savingEdit()"
      (click)="confirmEdit()"
    >
      Save
    </button>
  </div>
</modal>

<modal
  [id]="deleteModalId"
  [showHeader]="true"
  [showHeaderDivider]="false"
  [showFooterDivider]="false"
  [enableBackdropClose]="true"
  [heightClass]="'tw-h-auto'"
>
  <div slot="body" class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-2 tw-py-4">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 15C9.80222 15 9.60888 14.9413 9.44443 14.8315C9.27998 14.7216 9.15181 14.5654 9.07612 14.3827C9.00044 14.2 8.98063 13.9989 9.01922 13.8049C9.0578 13.6109 9.15304 13.4327 9.2929 13.2929C9.43275 13.153 9.61093 13.0578 9.80491 13.0192C9.99889 12.9806 10.2 13.0004 10.3827 13.0761C10.5654 13.1518 10.7216 13.28 10.8315 13.4444C10.9414 13.6089 11 13.8022 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73479 12 9.48043 11.8946 9.2929 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.2929 5.29289C9.48043 5.10536 9.73479 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11Z" fill="#9CA3AF"/>
    </svg>
    <p [innerHTML]="deleteModalMessage" class="tw-text-center tw-text-sm tw-text-gray-700 tw-font-inter tw-leading-relaxed tw-max-w-sm"></p>
    <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-3 tw-pt-2">
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-red-600 tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-red-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-red-500 disabled:tw-opacity-50"
        [disabled]="savingDelete()"
        (click)="confirmDelete()"
      >
        Yes, I'm sure
      </button>
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-gray-300 disabled:tw-opacity-50"
        [disabled]="savingDelete()"
        (click)="closeDeleteModal()"
      >
        No, cancel
      </button>
    </div>
  </div>
</modal>
